import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const TrendingSection: FC = () => {
  const trending = [...articles].sort((a, b) => b.viewCount - a.viewCount).slice(0, 5);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">
          <div className="lg:w-1/3">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
              热门内容
            </h2>
            <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
              根据播放量和互动数据，为你精选平台最受欢迎的ASMR内容。
            </p>
            <div className="hidden lg:block">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20cozy%20corner%20with%20vinyl%20record%20player%2C%20headphones%2C%20warm%20ambient%20light%2C%20cream%20walls%2C%20wooden%20furniture%2C%20peaceful%20music%20listening%20space%2C%20soft%20beige%20and%20amber%20tones%2C%20artistic%20composition%2C%20editorial%20photography&width=400&height=300&seq=trending-sidebar-01&orientation=landscape"
                alt="热门ASMR内容"
                className="w-full rounded-lg"
              />
            </div>
          </div>

          <div className="lg:w-2/3">
            <div className="space-y-3">
              {trending.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="flex items-start gap-4 p-4 rounded-lg hover:bg-background-100 transition-all duration-200 group border border-transparent hover:border-background-200/60"
                >
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5 ${
                    index < 3 ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-background-200 text-foreground-600'
                  }`}>
                    <span className="text-sm font-semibold">{index + 1}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 line-clamp-2 mb-1">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 line-clamp-1 leading-relaxed mb-2">{article.excerpt}</p>
                    <div className="flex items-center gap-4 text-xs text-foreground-400 flex-wrap">
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">{article.category}</span>
                      <span className="flex items-center gap-1">
                        <div className="w-3 h-3 flex items-center justify-center"><i className="ri-eye-line"></i></div>
                        {article.viewCount > 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount}
                      </span>
                      <span className="flex items-center gap-1">
                        <div className="w-3 h-3 flex items-center justify-center"><i className="ri-heart-line"></i></div>
                        {article.likeCount}
                      </span>
                      <span>{article.date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrendingSection;